module.exports = __webpack_public_path__ + "img/3.861f7cfc.png";